<template>
  <div class="competeFiles">
    <!-- 页头 -->
    <div class="page-header-style">
      <el-page-header @back="goBack" :content="$t('lang.title_competeFiles')"></el-page-header>
    </div>
    <el-card class="location">
      <!-- 封面 -->
      <div class="divL">
        <div>
          <span class="text-style">{{$t('lang.lab_cover1')}}</span>
        </div>
        <div class="margin-t20">
          <viewer :images="videoFaceArray">
            <img :src="this.videoFace" class="img-style"/>
          </viewer>          
        </div>
      </div>
      <!-- 比赛视频 -->
      <div class="divR">
        <div>
          <span class="text-style">{{$t('lang.lab_competeVideo1')}}</span>
        </div>
        <div class="margin-t20">
          <video ref="video" autoplay controls playsInline webkit-playsinline class="video-style">
            {{$t('lang.warning_video')}}
          </video>        
        </div>
      </div>
      <div class="divB" v-if="examine === true">
        <!-- 通过 -->
        <el-button type="primary" class="button-R-style" @click="onExamine(2)">{{$t('lang.lab_adopt')}}</el-button>
        <!-- 拒绝 -->
        <el-button class="button-L-style" @click="onExamine(3)">{{$t('lang.lab_refuse')}}</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:competeFiles
 *@Description:参赛文件
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-08-04
 */
export default {
  name: '',
  components: {},
  data() {
    return {
      competeId: '', // 赛事id
      playerId: '', // 选手id
      examine: false, // 是否为待审核
      videoFace: '', // 封面
      videoFaceArray: [], // 封面
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 获取投票详情列表数据
    getData() {
      this.$get(`/player/onLine/playerFile?competeId=${this.competeId}&playerId=${this.playerId}`).then(
        res => {
          if (res && res.code === 200) {
            this.playerId = res.data.playerId
            this.videoFace = res.data.videoFace
            this.$refs.video.src = res.data.videoUrl
            this.videoFaceArray.push(res.data.videoFace)
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 审核
    onExamine(value) {
      this.$get(`/player/review?competeId=${this.competeId}&playerId=${this.playerId}&status=${value}`).then(
        res => {
          if (res && res.code === 200) {
            window.history.go(-1)
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 返回
    goBack() {
      window.history.go(-1)
    }
  },
  created() {
    this.competeId = this.$route.query.competeId
    this.playerId = this.$route.query.playerId
    this.examine = this.$route.query.examine
    if (this.competeId !== '' && this.playerId !== '') {
      this.getData()
    }
  },
  mounted() {}
}
</script>

<style lang='scss'>
.competeFiles{
  .location{
    padding: 50px;
  }
  .divL{
    width: 50%;
    float: left;
  }
  .divR{
    width: 50%;
    float: right;
  }
  .divB{
    text-align:center;
  }
  .img-style {
    width: 550px;
    height: 380px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin-right: 20px;
  }
  .video-style{
    width: 550px;
    height: 380px;  
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin-right: 20px;  
  }
  .margin-t20{
    margin-top: 20px; 
    text-align:center;
  }
  .text-style{
    font-weight:bold;
    font-size: 18px; 
  }
  .button-R-style{
    margin-right: 50px;
    margin-top: 100px;
    width: 100px;
    height: 60px;
  }
  .button-L-style{
    margin-top: 100px;
    width: 100px;
    height: 60px;
  }
}
</style>
